import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, nextTick, computed } from 'vue';
import { useRouter } from 'vue-router/composables';
import { UIModule } from '@/modules/common/store/UIModule';

import { ButtonBoxLaunch } from '@warrenbrasil/nebraska-web';
import {
  trackInvestClick,
  trackDepositClick,
  trackTransferClick
} from '../track-events';

import {
  ButtonAction,
  HomeBalanceHero
} from '@/modules/home/services/balances';

import type { Action } from './types';
import HomeHeroActionsLoader from './HomeHeroActionsLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHeroActions',
  props: {
    isLoading: { type: Boolean },
    disableActions: { type: Boolean },
    isOverdue: { type: Boolean },
    heroButtons: null
  },
  setup(__props: any) {

const props = __props as {
  isLoading?: boolean;
  disableActions?: boolean;
  isOverdue: boolean;
  heroButtons: HomeBalanceHero;
};

const ITEM_TRANSITION_BASE_DELAY = 400;



const addLoadedClass = computed(() => !UIModule.getIsOpenWelcomeCurtain);

const router = useRouter();
const actionItemsRefs = ref<HTMLElement[]>([]);

function setActionItemRef(el: HTMLElement | null) {
  if (el) {
    actionItemsRefs.value.push(el);
  }
}

const buttons = ref<Action[]>([]);

onMounted(async () => {
  await nextTick();
  addAnimationDelayOnButtons();
});

watch(
  () => props.heroButtons,
  newVal => {
    if (newVal?.buttons?.length) {
      buttons.value = setButtons(newVal);
    }
  },
  { immediate: true, deep: true }
);

function setButtons(heroButtons: HomeBalanceHero): Action[] {
  return heroButtons.buttons.map(({ label, icon, isActive, action }) => {
    return {
      label,
      icon,
      disabled: !isActive,
      ...getHandlers(action)
    };
  });
}

function getHandlers(action: ButtonAction) {
  return {
    [ButtonAction.Invest]: {
      handler: goToInvestmentFlow,
      class: 'home-cash-actions__to_invest_container'
    },
    [ButtonAction.Deposit]: {
      handler: depositAction
    },
    [ButtonAction.Transfer]: {
      handler: handleTransferClick
    }
  }[action];
}

function goToInvestmentFlow() {
  if (props.isOverdue) {
    regulatoryUpdate();
    return;
  }

  router.push({ name: 'investment' });
  trackInvestClick();
}

function depositAction() {
  router.push({ name: 'deposit-pix' });
  trackDepositClick();
}

function handleTransferClick() {
  trackTransferClick();
  goToNewTransferPage();
}

function goToNewTransferPage() {
  router.push({ name: 'new-transfer' });
}

function regulatoryUpdate() {
  router.push({ name: 'regulatoryUpdateAnnouncement' });
}

function listItemClasses(isDisabled: boolean) {
  return [
    'home-cash-actions__item',
    isDisabled && 'home-cash-actions__item--disabled'
  ];
}

function addAnimationDelayOnButtons() {
  actionItemsRefs.value.forEach((item, index) => {
    const delay = ITEM_TRANSITION_BASE_DELAY + index * 60;
    item.style.transitionDelay = `${delay}ms`;
  });
}

return { __sfc: true,ITEM_TRANSITION_BASE_DELAY, props, addLoadedClass, router, actionItemsRefs, setActionItemRef, buttons, setButtons, getHandlers, goToInvestmentFlow, depositAction, handleTransferClick, goToNewTransferPage, regulatoryUpdate, listItemClasses, addAnimationDelayOnButtons, ButtonBoxLaunch, HomeHeroActionsLoader }
}

})